import { useEffect } from 'react';

import { PagePrompt, setPagePrompts, clearPagePrompts } from './pagePrompts';
import { useAppDispatch } from '../hooks';

/**
 * Hook that registers page prompts in Redux when a resource page mounts.
 * Each prompt is a {promptButtonId, title} pair — the backend resolves the
 * full prompt from the button id and reads any per-entity context from
 * agent_context, so no explicit params are needed. Clears on unmount.
 */
export const useRegisterPagePrompts = (prompts: readonly PagePrompt[] | null) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (prompts) {
      dispatch(setPagePrompts(prompts));
    }

    return () => {
      dispatch(clearPagePrompts());
    };
  }, [dispatch, prompts]);
};
